import React from "react"
import Layout from "../templates/layout"
import { graphql } from "gatsby"
import SEO from "../components/seo"
import Reveal from "../components/reveal"

const SectionCard = ({ item }) => {
  return (
    <div>
      <div className="flex mb-2 items-center">
        <img
          src={item.icon.url}
          alt={item.icon.alt}
          className="rounded-md mr-2 text-blue w-8 h-8"
        />
        <h3 className="font-semibold mb-0 mt-0 text-lg">
          {item["title"][0].text}
        </h3>
      </div>
      <div className="font-normal text-sm">{item["description"][0].text}</div>
    </div>
  )
}

const ProfileCard = ({ item }) => {
  return (
    <div>
      <Reveal once={true} threshold={.5} dur={.4} y={20}>
      <img src={item.image.url} alt={item.image.alt} className="rounded-md" />
      <div className="font-semibold mb-1 mt-2 text-base text-center">
        {item["full_name"][0].text}
      </div>
      <div className="font-normal text-xs text-center">
        {item["role"][0].text}
      </div></Reveal>
    </div>
  )
}

export default function People({ location, data }) {
  const sectionItems =
    data.allPrismicPeoplePage.edges[0].node.dataRaw.body[0].items
  const peopleItems =
    data.allPrismicPeoplePage.edges[0].node.dataRaw.body[1].items
  return (
    <>
      <SEO
        title="Bankjoy — Team"
        description="Bankjoy delivers award-winning banking technology, including mobile banking, online banking, e-statements, online account opening, online loan origination, and conversational AI to banks and credit unions — big and small."
        url="https://bankjoy-headless.vercel.app/people"
      />

      <Layout location={location} containerClassName="px-8 max-w-6xl mx-auto">
        <div className="max-w-4xl text-3xl md:text-5xl font-bold mt-8 mb-20">
          We are on a quest to build the high quality banking products we have
          always wanted to experience ourselves.
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-16 gap-y-8">
          {sectionItems.map((item, index) => (
            <SectionCard item={item} key={index} />
          ))}
        </div>
        <h3 className="mt-20 font-bold text-xl md:text-4xl mb-12 text-center">
          Meet Our Team
        </h3>
        <div className="grid grid-cols-3 md:grid-cols-4 gap-x-6 gap-y-12">
          {peopleItems.map((item, index) => (
            <ProfileCard item={item} key={index} />
          ))}
        </div>
      </Layout>
    </>
  )
}

export const query = graphql`
  {
    allPrismicPeoplePage {
      edges {
        node {
          dataRaw
        }
      }
    }
  }
`
